<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "ContestViewTemplate",
	};
</script>

<style scoped>

</style>
